module.exports = __webpack_public_path__ + "img/bg.b6ad0289.jpg";